import { styled } from '@mui/material/styles';

interface InputProps {
    isEndAdornmentDoubleComponent: boolean;
}

export const StyledInput = styled('input')<InputProps>(({ isEndAdornmentDoubleComponent }) => ({
    paddingRight: `${isEndAdornmentDoubleComponent ? 65 : 39}px`
})); 